<template>
  <div id="LOGO">
    <div class="swiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="item in bannerList" :key="item.images">
          <img :src="item.images" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getBanner } from "@/https/http";
import Swiper from "swiper";
import "../../../node_modules/swiper/css/swiper.min.css";
export default {
  data() {
    return {
      bannerList: "",
    };
  },
  mounted() {
    this.$nextTick(function () {
      new Swiper(".swiper", {
        loop: true,
        speed: 900,
        pagination: {
          el: ".swiper-pagination",
          clickable: true, // 允许点击小圆点跳转
          bulletClass : 'swiper-pagination-bullet',
          bulletElement : 'li',
        },
        direction: "horizontal",
        autoplay: {
          delay: 3000,
        },
        // mousewheel: false,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
      });
    });
  },
  created() {
    getBanner({ type: 1 }).then((res) => {
      console.log("getBanner", res.result);
      this.bannerList = res.result;
    });
    // getBanner({ class: 17781 }).then((res) => {
    //   console.log("getBanner", res.result);
    // });
  },
};
</script>
<style lang="scss" scoped>
@media screen and (min-width: 1020px){
  * {
  width: 100%;
  padding: 0;
  margin: 0;
  position: relative;
}
#LOGO {
  width: 100%;
  /* height: 396px; */
  min-width: 48.8%;
  min-height: 48.8%;
  z-index: 0;
  overflow: hidden;
  /* img {
    width: 100%;
    height: 100%;
    min-width: 1427px;
  } */
  .swiper {
    width: 100%;
    height: 100%;
    min-width: 1427px;
    img {
      width: 100%;
      height: 100%;
      min-width: 1427px;
    }
  }
}
}
@media screen and(max-width:1020px){
  #LOGO {
    width: 100%;
    overflow: hidden;
    .swiper {
      img {
        width: 100%;
      }
    }
}
}

</style>